import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Abandoned Carts list configuration
 * Unsubmitted orders with no recent activity (embedded in client view)
 *
 * PD-13314: "abandoned" is defined by LAST MODIFIED date, not creation
 * date — see the note on abandonedCartsList (order/lists/abandoned-carts).
 */
export const clientEmbeddedAbandonedCartsList: ListBuilderList = {
	id: 'client-embedded-abandoned-carts',
	cacheTTL: 600000,
	name: 'Abandoned Carts',
	type: 'default',
	active: true,
	sortOrder: 6,
	requiredFeature: 'order-entry',
	columns: createStandardOrderClientEmbeddedColumns(),
	description:
		'Unsubmitted orders with no recent activity that may need follow-up',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderModifiedDateRange: {
			defaultValue: [
				{
					id: 'until-yesterday',
					label: 'Until Yesterday',
					data: {
						startDate: null,
						endDate: '{{DATE:-1d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [{ id: '1', label: 'Unsubmitted' }],
		},
		orderOrigin: {
			defaultValue: [
				{ id: '1', label: 'CRM' },
				{ id: '3', label: 'E-Commerce' },
			],
		},
	},
};
